import { Typography, Button, Grid, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import { ApplicantInfo } from '../../../shared/VolunteerApplicationServiceTypes';
import { useInterviewLandingPage } from '../InterviewLandingPage/useInterviewLandingPage';
import { ANSWERS_REVIEW, INTERVIEW_LANDING } from '../../../shared/Routes';
import { ApplicantDetailsTable } from '../ApplicantDetailsTable';
import Icon from '../../../components/ui-components/Icon';
import LeftArrowWhite from '../../../assets/images/arrow-left-white.svg';
import RightArrowWhite from '../../../assets/images/arrow-right-white.svg';

const { Text } = Typography;
const { useBreakpoint } = Grid;

interface ApplicantAnswersLandingPageProps {
	applicantInfo?: ApplicantInfo;
}

const SectionHeader = ({
	heading,
	isMobile,
}: {
	heading: string;
	isMobile: boolean;
}) => {
	const { t } = useTranslation();
	const { navigateToPage } = useInterviewLandingPage();

	return (
		<div className="relative flex items-center justify-between">
			{!isMobile && (
				<Button
					type="primary"
					onClick={() => navigateToPage(INTERVIEW_LANDING)}
					icon={<Icon src={LeftArrowWhite} width={'w-4'} height={'h-4'} />}
					className="absolute left-0 font-bold text-sm"
				>
					{t('back')}
				</Button>
			)}
			<Text className="flex-grow text-center font-sans font-semibold text-lg text-secondary-black my-4">
				{heading}
			</Text>
		</div>
	);
};

export const ApplicantAnswersReviewLandingPage = ({
	applicantInfo,
}: ApplicantAnswersLandingPageProps) => {
	const { t } = useTranslation();
	const screens = useBreakpoint();
	const isMobile = !screens.sm;
	const { navigateToPage } = useInterviewLandingPage();

	return (
		<div className="flex justify-center">
			<div
				className={`flex flex-col h-full min-h-0 p-[8px] ${
					isMobile ? 'w-full' : 'w-[90%]'
				}`}
			>
				<SectionHeader
					heading={t('candidateApplicationReview')}
					isMobile={isMobile}
				/>
				<ApplicantDetailsTable applicantInfo={applicantInfo} />
				<div className="flex justify-center">
					<div
						className={`flex flex-col items-center bg-white p-4 rounded-lg shadow-md my-4 ${
							!isMobile ? 'w-3/4' : 'w-full'
						}`}
					>
						<Text className="text-base font-semibold text-center mt-2 text-secondary-black">
							{t('setContextPolitely')}
						</Text>
						<Divider className="border border-solid border-gray-200" />
						<p className="font-sans font-semibold text-sm text-gray-650 w-full text-left">
							{t('followingAreAnswersProvidedByCandidate')}
						</p>
						<p className="font-sans font-semibold text-sm text-gray-650 w-full text-left">
							{t('reviewTheAnswersInDifferentCategories')}
						</p>
						<div
							className={`flex ${
								!isMobile ? 'justify-end' : 'justify-center'
							} w-full gap-2 mt-4`}
						>
							<Button
								className="font-bold text-sm"
								onClick={() => navigateToPage(INTERVIEW_LANDING)}
							>
								{t('cancel')}
							</Button>
							<Button
								type="primary"
								onClick={() => navigateToPage(ANSWERS_REVIEW)}
								className="font-bold text-sm"
							>
								{t('next')}
								<Icon src={RightArrowWhite} width={'w-5'} height={'h-5'} />
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
